<template>
  <div
    class="rich_text"
    :class="{ dfc: flex }"
    v-html="filterContent"
    @click="showImgPreview($event)"
    ref="richTextRef"
  ></div>
</template>
<script>
import { filterXSS } from 'xss'
import xss from 'xss'
import { isWx, isMobile } from '@/utils/utils'
import Hls from '@/plugin/js/hls.js'
const styleWhiteList = [
  'p',
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'div',
  'blockquote',
  'pre',
  'code',
  'em',
  'q',
  's',
  'small',
  'strike',
  'strong',
  'sub',
  'sup',
  'tt',
  'var',
  'b',
  'u',
  'i',
  'center',
  'dl',
  'dt',
  'dd',
  'ol',
  'ul',
  'li',
  'fieldset',
  'form',
  'label',
  'legend',
  'table',
  'caption',
  'tbody',
  'tfoot',
  'thead',
  'tr',
  'th',
  'td',
  'article',
  'aside',
  'details',
  'figure',
  'figcaption',
  'footer',
  'header',
  'menu',
  'nav',
  'section',
  'time',
  'mark',
]
let whiteList = Object.assign(filterXSS.whiteList, {
  source: ['src', 'type'],
  textarea: ['style', 'placeholder'],
  svg: ['style', 'src'],
  a: ['style', 'href', 'title'],
  // style: [],
  'wx-rich-text': [],
  'mp-common-profile': [],
  video: [
    'autoplay',
    'controls',
    'crossorigin',
    'loop',
    'muted',
    'playsinline',
    'poster',
    'preload',
    'src',
    'height',
    'width',
    'presrc',
    'class',
  ],
  img: ['style', 'url', 'title', 'src'],
})
styleWhiteList.forEach(key => {
  whiteList[key] = ['style']
})

export default {
  name: 'RichText',
  props: {
    content: {
      default: '',
      type: String,
      required: true,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    extWhiteList: {
      type: Object,
      default: () => {},
    },
    iPrevImg: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterContent() {
      if (this.content == undefined) {
        return ''
      }
      const options = {
        whiteList: Object.assign(whiteList, this.extWhiteList),
        css: false,
      }
      const myxss = new xss.FilterXSS(options)
      return myxss.process(this.content)
    },
    srcList() {
      if (this.content == undefined) {
        return ''
      }
      let imgArr = this.content.match(/<img[^>]*src=['"]([^'"]+)[^>]*>/gi)
      if (!imgArr) return ''
      return imgArr.map(item => {
        return item.replace(
          /<img[^>]*src=['"]([^'"]+)[^>]*>/gi,
          (match, p1) => p1
        )
      })
    },
  },
  watch: {
    content: {
      immediate: true,
      handler(v) {
        console.log('content=>', v)
      },
    },
    filterContent: {
      immediate: true,
      deep: true,
      handler(cont) {
        if (cont) {
          this.$nextTick(() => {
            const videoList =
              (this.$refs.richTextRef &&
                this.$refs.richTextRef.querySelectorAll(
                  'video.editor-video-js'
                )) ||
              []
            Array.from(videoList).forEach(function (e) {
              var hasPresrc = e.getAttribute('presrc')
              if (hasPresrc) {
                if (isMobile()) {
                  e.setAttribute('preload', 'auto')
                  e.setAttribute('src', hasPresrc)
                } else {
                  var hls = new Hls()
                  e.removeAttribute('src')
                  hls.loadSource(
                    (e.getAttribute('presrc') || '').replace('http://', '//')
                  )
                  hls.attachMedia(e)
                }
                e.removeAttribute('presrc')
              }
            })
          })
        }
      },
    },
  },
  methods: {
    showImgPreview(e) {
      if (!this.iPrevImg) return
      if (e.target.tagName == 'IMG' && e.target.parentNode.tagName != 'A') {
        if (isWx()) {
          wx.previewImage({
            current: e.target.src,
            urls: this.srcList,
          })
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.rich_text {
  white-space: pre-wrap;
  line-height: normal;
  padding-bottom: 0.7rem;
  &.dfc {
    display: flex;
    flex-direction: column;
  }
  ::v-deep(img) {
    max-width: 100%;
    vertical-align: top;
  }
  ::v-deep(video) {
    width: 100%;
  }
  ::v-deep(em) {
    font-style: italic;
  }
  ::v-deep(strong) {
    font-weight: bold;
  }
  ::v-deep(h1) {
    font-weight: bold;
  }
  ::v-deep(h2) {
    font-weight: bold;
  }
  ::v-deep(h3) {
    font-weight: bold;
  }
  ::v-deep(h4) {
    font-weight: bold;
  }
  ::v-deep(h5) {
    font-weight: bold;
  }
  ::v-deep(h6) {
    font-weight: bold;
  }
  ::v-deep(ul li) {
    list-style: disc !important;
  }
  ::v-deep(ol) {
    padding-inline-start: 12px;
  }
  ::v-deep(ol li) {
    list-style: decimal !important;
  }
  ::v-deep(blockquote) {
    margin: 0;
    padding-left: 10px;
    border-left: 3px solid #dbdbdb;
  }
}
</style>
<style>
.rich_text * {
  max-width: 100% !important;
}
</style>
